<template>
    <div>       
        <colaborador-lista></colaborador-lista>
    </div>
</template>

<script>
import ColaboradoresLista from '@/components/gestion/ColaboradoresLista'

export default {
    name: 'Colaborador',
    components: {
        'colaborador-lista': ColaboradoresLista
    },
    data: () => {
        return {
            
        }
    }
}
</script>

<style>

</style>